//Styles
import { SPECIAL_ROUTE_HARACTER, getCurrentOption } from "../../global/functions/functrions";
import Styles from "./LeftPanelMenu.module.scss";
import classnames from "classnames"

interface MenuProps {
    activeValue: any;
    menuContent: any;
    showHeaderBorder?: boolean;
    handleOptionClick: (optionId: any) => void;
    setTitle?: (title: string) => void;
    onSuccessfulSubmission?: (data: any) => void;
    specialTheme?: "spotify" | "iMessage";
}

const LeftPanelMenu = ({ menuContent, activeValue, showHeaderBorder = false, handleOptionClick, setTitle, onSuccessfulSubmission, specialTheme }: MenuProps) => {



    const handleClick = (id: any, title: string, option: any) => {
        handleOptionClick(activeValue + SPECIAL_ROUTE_HARACTER + id)
        setTitle?.(title)
        onSuccessfulSubmission?.(option)
    }

    const getIcon = (block: any) => {
        if (!String(typeof (block.icon)).toLowerCase().includes("object")) {
            return (<img src={block.icon} className={Styles.icon} />)
        }
        else {
            return block.icon
        }
    }

    const ui: any = []

    var currentActiveOption = getCurrentOption(activeValue)

    const getUI = (contentArray: any[]) => {
        contentArray.map((block: any,index:number) => {
            block.label && ui.push(
                <div key={index+"_"+block.id + "_" + block.label} className={classnames(Styles.option, block.options && (showHeaderBorder ? Styles.title_with_border : Styles.title), block.id === currentActiveOption && Styles.active)} onClick={() => {
                    !block.options && handleClick(block.id, block.label, block)
                }}>
                    {block.icon && <div className={Styles.icon_container}>
                        {getIcon(block)}
                    </div>}
                    <div className={Styles.labels}>
                        <div className={classnames(Styles.label,block.subLabel && Styles.heavy)}>
                            {block.label}
                        </div>
                        <div className={Styles.sub_label}>
                            {block.subLabel}
                        </div>
                    </div>
                </div>
            )
            block.options && getUI(block.options)
            block.options && ui.push(<div className={Styles.divider} key={`${index}_divider_`}/>)
        })


        return ui;
    }
    return (
        <div className={classnames(Styles.container, specialTheme && Styles[specialTheme])}>
            {
                getUI(menuContent)
            }
        </div>
    )
}

export default LeftPanelMenu
